var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130a",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 3.6c.7 0 1.3.1 2 .3L10 0 8 3.9c.7-.2 1.3-.3 2-.3ZM20 10l-3.9-2c.2.6.3 1.3.3 2s-.1 1.3-.3 2l3.9-2ZM15.7 7.1 17.1 3l-4.2 1.4c1.2.5 2.2 1.5 2.8 2.7ZM7.1 4.3 2.9 2.9 4.3 7c.6-1.1 1.6-2.1 2.8-2.7ZM3.6 10c0-.7.1-1.3.3-2L0 10l3.9 2c-.2-.7-.3-1.3-.3-2ZM12.9 15.7l4.2 1.4-1.4-4.1c-.6 1.1-1.6 2.1-2.8 2.7ZM10 16.4c-.7 0-1.3-.1-2-.3l2 3.9 2-3.9c-.7.2-1.3.3-2 .3ZM4.3 12.9 2.9 17l4.2-1.4c-1.2-.5-2.2-1.5-2.8-2.7ZM10 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130b",
    viewBox: "0 0 20 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3.6C10.7 3.6 11.3 3.7 12 3.9L10 0L8 3.9C8.7 3.7 9.3 3.6 10 3.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 10L16.1001 8C16.3001 8.6 16.4001 9.3 16.4001 10C16.4001 10.7 16.3001 11.3 16.1001 12L20.0001 10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6999 7.1L17.0999 3L12.8999 4.4C14.0999 4.9 15.0999 5.9 15.6999 7.1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0999 4.30002L2.8999 2.90002L4.2999 7.00002C4.8999 5.90002 5.8999 4.90002 7.0999 4.30002Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1 12.1C10.8 10.1 9.1 8.5 7 8.5C4.7 8.5 2.8 10.4 2.8 12.7C1.2 12.9 0 14.2 0 15.9C0 17.6 1.4 19 3.2 19H10.5C12.4 19 14 17.4 14 15.5C14 13.8 12.8 12.4 11.1 12.1ZM10.5 17H3.2C2.5 17 2 16.5 2 15.9C2 15.3 2.4 14.8 3 14.8L4.8 14.6V12.7C4.8 11.5 5.8 10.6 7 10.6C8.1 10.6 9 11.4 9.2 12.5L9.4 13.9L10.8 14.2C11.5 14.3 12 15 12 15.7C12 16.3 11.3 17 10.5 17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9998 7.1C9.4998 7.1 11.5998 8.7 12.2998 11C13.0998 11.3 13.7998 11.9 14.2998 12.5C14.6998 11.8 14.9998 10.9 14.9998 10C14.9998 7.2 12.7998 5 9.9998 5C8.2998 5 6.6998 5.9 5.7998 7.2C6.1998 7.2 6.5998 7.1 6.9998 7.1Z",
    fill: "currentColor"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130c",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.4 14c-.2-2.2-2.1-4-4.4-4-2.4 0-4.4 2-4.4 4.4h-.4c-1.8 0-3.3 1.5-3.3 3.3C2 19.5 3.5 21 5.3 21H13c2 0 3.7-1.6 3.7-3.7 0-1.5-.9-2.8-2.3-3.3ZM13 19H5.3c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h.1l2.4.3-.2-2.4C7.6 13 8.7 12 10 12c1.2 0 2.3.9 2.4 2.2l.1 1.2 1.1.5c.6.3 1 .9 1 1.5.1.9-.7 1.6-1.6 1.6ZM20.1 8.9c-.2-1.9-1.8-3.4-3.8-3.4-2.1 0-3.8 1.7-3.8 3.8v.3c1.4.7 2.5 2.1 2.8 3.7.7.4 1.3 1 1.7 1.7h1.8c1.7 0 3.2-1.4 3.2-3.2 0-1.3-.8-2.4-1.9-2.9ZM18.8 13H18c-.3-.3-.6-.7-1-.9-.5-1.4-1.3-2.6-2.4-3.5.3-.6.9-1.1 1.6-1.1.9 0 1.7.7 1.8 1.6l.1 1.2 1.1.5c.4.2.7.6.7 1.1.1.6-.4 1.1-1.1 1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3C5.2 3 3 5.2 3 8c0 1.7.9 3.2 2.2 4.1.9-1.8 2.7-3.1 4.9-3.1.5 0 1 .1 1.4.2 0-1.1.4-2.2 1.1-3C11.9 4.4 10.1 3 8 3Zm1.9 4c-1.8 0-3.5.7-4.8 1.9C5 8.6 5 8.3 5 8c0-1.7 1.3-3 3-3 .9 0 1.8.4 2.3 1.1-.1.3-.3.6-.4.9Z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130d",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 9.4c-.3-3-2.9-5.4-6-5.4-3.3 0-6 2.7-6 6v.1c-.2-.1-.3-.1-.5-.1C4 10 2 12 2 14.5S4 19 6.5 19H17c2.8 0 5-2.2 5-5 0-2.1-1.2-3.8-3-4.6ZM17 17H6.5C5.1 17 4 15.9 4 14.5S5.1 12 6.5 12h.3l2.4.3L9 9.9C9 7.8 10.8 6 13 6c2.1 0 3.8 1.5 4 3.6l.1 1.2 1.1.5c1.1.4 1.8 1.5 1.8 2.7 0 1.7-1.3 3-3 3Z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130e",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 5H11.8c-2.6 0-5-.8-6.8-2H2c2.2 2.4 5.7 4 9.8 4H22V5ZM9.847 12.507l-.848-.53-1.643 2.629.848.53 1.643-2.63ZM8.389 9.228l-.848-.53-1.908 3.053.848.53 1.908-3.053ZM16.314 8.555l-.848-.53-3.391 5.428.848.53 3.391-5.428ZM16.383 15.233l-.848-.53-1.908 3.053.848.53 1.908-3.053ZM6.966 16.961l-.848-.53-1.484 2.375.848.53 1.484-2.375ZM12.26 8.55l-.848-.53-1.272 2.036.848.53L12.26 8.55ZM11.453 16.337l-.848-.53-1.908 3.053.848.53 1.908-3.053ZM19.808 9.838l-.849-.53-1.748 2.798.848.53 1.748-2.798Z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130f",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 5H11.8c-2.6 0-5-.8-6.8-2H2c2.2 2.4 5.7 4 9.8 4H22V5ZM12.346 8.552l-.848-.53-7.419 11.872.848.53 7.419-11.872ZM8.826 8.544l-.848-.53-3.391 5.428.848.53 3.391-5.428ZM16.346 8.552l-.848-.53-7.419 11.872.848.53 7.419-11.872ZM20.555 8.516l-.848-.53-7.419 11.872.848.53 7.419-11.872Z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130g",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.346 8.552-.848-.53-7.419 11.872.848.53 7.419-11.872ZM20.555 8.516l-.848-.53-7.419 11.872.848.53 7.419-11.872ZM6.1 3.6c-.4-.2-.8-.4-1.1-.6H2c.9 1 2.1 1.9 3.4 2.5l.7-1.9ZM14.5 5l-1.4 2H22V5h-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3h7l-6 7h3L3 22l4-9H3L8 3Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130h",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 5H11.8c-2.6 0-5-.8-6.8-2H2c2.2 2.4 5.7 4 9.8 4H22V5ZM19 14H5v2h14v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.634 21.562 1.732-1-7-12.124-1.732 1 7 12.124Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.366 9.438-1.732-1-7 12.124 1.732 1 7-12.124Z"
  })))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130i",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 10H3v1h9v-1ZM22 10h-8v1h8v-1ZM21 7H2v1h19V7ZM14 4H6v1h8V4ZM21 4h-4v1h4V4ZM22 13h-4v1h4v-1ZM8 13H4v1h4v-1ZM13 16H5v1h8v-1ZM21 19H4v1h17v-1ZM19 16h-4v1h4v-1ZM16 13h-6v1h6v-1Z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130j",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 12H4v2h16v-2ZM13 15H4v2h9c1.6.1 3.1.7 4.3 1.7l1.9-1c-1.7-1.6-3.8-2.6-6.2-2.7ZM15 5v2c.6 0 1 .4 1 1s-.4 1-1 1H4v2h11c1.7 0 3-1.3 3-3s-1.3-3-3-3Z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-130k",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 19H3v1h18v-1ZM5 4h15v2h-1s-.7-.3-2 1-4 12-4 12h-2C14.8 6.5 5 6 5 6V4Z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-aim",
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.667 6.333H.333v1.334h3.334V6.333ZM13.667 6.333h-3.333v1.334h3.333V6.333ZM7.667.333H6.334v3.334h1.333V.333ZM7.667 10.333H6.334v3.334h1.333v-3.334ZM7 8.333a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 1.667c-2.933 0-5.333 2.4-5.333 5.333 0 2.933 2.4 5.333 5.333 5.333 2.933 0 5.333-2.4 5.333-5.333 0-2.933-2.4-5.333-5.333-5.333ZM7 11.2A4.183 4.183 0 0 1 2.8 7c0-2.333 1.867-4.267 4.2-4.267S11.2 4.6 11.2 7c0 2.4-1.867 4.2-4.2 4.2Z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-add",
    viewBox: "0 0 12 12"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 5.333H0v1.334h12V5.333Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.667 12V0H5.332v12h1.333Z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 5h17l-7 8v9l-3-2v-7L4 5Z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-map",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_13436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5H21L14 13V22L11 20V13L4 5Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 23V19L19 23H23Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_13436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(4 5)"
  }))))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-map-active",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_13698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5H21L14 13V22L11 20V13L4 5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 23V19L19 23H23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 3,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_13698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(4 5)"
  }))))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-filter-active",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8489_229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 5H21L14 13V22L11 20V13L4 5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 19,
    r: 3,
    fill: "#FFB800"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8489_229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(4 5)"
  }))))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-user",
    viewBox: "0 0 16 15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15V13L6 9H10L16 13V15H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z",
    fill: "white"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-fleet",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 7H21L20.2 11H8.4L6 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4H17V8H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3H9V8H10V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3H13V8H14V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 16H3L3.8 20H15.6L18 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13H4V17H7V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12H14V17H15V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12H10V17H11V12Z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-close-16",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.992 1.006-12 12 1.414 1.414 12-12-1.415-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.414 12.992-12-12L1 2.406l12 12 1.414-1.414Z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalog-history",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 13V6l5.36 4.33L16 13ZM8 11v7l-5.36-4.33L8 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.91 8.91-.5.51A6 6 0 0 1 10 17.65v2.09a8.24 8.24 0 0 0 2 .26 8 8 0 0 0 7.93-9.07l-2.02-2.02ZM12 4a8 8 0 0 0-7.93 9.07l2 2 .5-.51A6 6 0 0 1 14 6.35V4.26A8.24 8.24 0 0 0 12 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.747 13.99-2.369-2.368-.707.707 2.369 2.369.707-.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.4 7.781-2.106 4.292.898.44 2.105-4.291-.898-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-zoom-minimum",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.5 0 10 0Zm.3 18.1c-2.7 0-4.8-.9-6.1-2.3-.5-.5-.5-1.4-.1-2 .5-.6.4-1.5 0-2.1l-.2-.3c-.3-.3-.4-.7-.5-1.2l-.5-3.6c0-.3 0-.5.2-.8.2-.4.7-.6 1.2-.6H5c.6 0 1.2-.1 1.7-.5l1.5-1.1c.3-.2.4-.5.3-.8-.1-.3.2-.8.6-.8h1c1.6 0 3 .4 4.2 1 .3.2.3.5.2.8-.1.1-.1.2-.2.2h-.1c-.3.1-.6.1-.8 0h-.1c-.3-.2-.7-.2-1 0l-.4.2c-.2.1-.4.2-.6.2l-.3.1h-.7c-.4 0-.7.1-1 .4l-.3.2c-.2.2-.4.5-.4.8 0 .2 0 .3.1.5l.1.2c.2.4.6.7 1 1l.4.2c.1 0 .1.1.2.1.2.2.4.3.7.3h.2c.3 0 .7-.1.9-.4l.2-.2c.2-.2.5-.3.8-.1.3.1.4.4.4.7v.1c0 .4-.3.7-.7.7h-.8c-.1 0-.2 0-.3.1-.5.2-1.1.1-1.5-.2l-.3-.1c-.5-.3-1.1-.3-1.7-.1h-.1c-.6.2-1 .7-1.1 1.3-.1.4 0 .7.1 1.1l.1.4c.2.4.6.8 1 .9.7.2 1.2.9 1.1 1.7l-.1.9v.6l.1.3c.1.6.7 1.1 1.4 1 .4 0 .7-.2 1-.6l1.4-1.9c.1-.2.3-.4.4-.7.1-.1.1-.3.2-.4.1-.2.1-.5 0-.8 0-.1 0-.2-.1-.3l-.3-1.1v-.3c.1-.3.5-.3.7 0l.3.6c.2.3.6.5 1 .3l.6-.3c.2-.1.3-.4.3-.6-.1-.2-.2-.3-.4-.4-.1 0-.2-.1-.3-.2l-.3-.4c-.1-.1-.1-.3 0-.4.1-.1.2-.2.4-.1l1.1.4.6.3h.1c.5.5.8 1.1.6 1.8-1 3.5-3.5 6.3-7.8 6.3Z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vessels-list",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 11H7v1h6v-1ZM11 13H7v1h4v-1ZM13 9H7v1h6V9ZM13 7h-3v1h3V7ZM13 5h-3v1h3V5ZM10 18h11l-.6 3h-8.6L10 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15h-2v4h2v-4ZM13 15h-1v4h1v-4ZM16 15h-1v4h1v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16H6V7h3V4h5v9h2V2H8L4 6v12h5v-2Z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-information",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0085FF",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 7h-4v4h4V7ZM18 13h-4v12h4V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 24h-3v1h3v-1Z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-warning",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEC41",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18 21h-4v4h4v-4ZM18 7h-4v12h4V7Z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-error",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E22900",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.424 7.161 7.161 23.425l1.414 1.414L24.84 8.575l-1.415-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.839 23.424 8.575 7.161 7.161 8.575 23.425 24.84l1.414-1.415Z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-technical_error",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E22900",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23.424 7.161 7.161 23.425l1.414 1.414L24.84 8.575l-1.415-1.414Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.839 23.424 8.575 7.161 7.161 8.575 23.425 24.84l1.414-1.415Z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-analytics",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 12L13.5 3.1C13 3.1 12.5 3 12 3C7 3 3 7 3 12C3 17 7 21 12 21C16.7 21 20.5 17.5 21 12.9L12 12ZM12 19C8.1 19 5 15.9 5 12C5 8.4 7.7 5.5 11.1 5.1L9.6 13.8L18.4 14.7C17.4 17.2 14.9 19 12 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3 3.30005L13 11L21 11.9C21 7.80005 18.1 4.30005 14.3 3.30005Z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalog-areas",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3L4 7.5V16.5L12 21L20 16.5V7.5L12 3ZM18 15.33L12 18.71L6 15.33V8.67L12 5.29L18 8.67V15.33Z",
    fill: "currentColor"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 11.5-5-5L4.5 5 8 8.5 11.5 5 13 6.5l-5 5Z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-edit",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4174_5148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4L4 15V20H9L20 9L15 4ZM9 18L6 15L15 6L18 9L9 18Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.307 6.98623L8.14697 15.1462L8.85408 15.8533L17.0141 7.69333L16.307 6.98623Z",
    fill: "#464958"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4174_5148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  }))))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-trash",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4174_5149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6H5V8H19V6Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H8V7H16V4Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 9V21H18V9H6ZM16 19H8V10H16V19Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11H10V18H11V11Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11H13V18H14V11Z",
    fill: "#464958"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4174_5149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 17,
    fill: "white",
    transform: "translate(5 4)"
  }))))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-plus",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3525_8477)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 11H3V13H21V11Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21L13 3H11L11 21H13Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3525_8477"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  }))))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-minus",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5231_2018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 11H4V13H20V11Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5231_2018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 2,
    fill: "currentColor",
    transform: "translate(4 11)"
  }))))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-minus-20",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 14,
    height: 2,
    fill: "currentColor"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-away",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4291_7910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 9V11H5V5H7V3H3V13H13V9H11Z",
    fill: "#6CA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2H14V8H12V5.5L9 8.5L7.5 7L10.5 4H8V2Z",
    fill: "#6CA2FF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4291_7910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(3 2)"
  }))))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-marketplace",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 2H16V4H22V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2475 2.30272L16.2877 6.26248L17.7019 7.67668L21.6617 3.71692L20.2475 2.30272Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 2H20V8H22V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10C10.7 10 10.5 10 10.3 10.1C11 10.3 11.5 11 11.5 11.7C11.5 12.6 10.7 13.4 9.8 13.4C9 13.4 8.4 12.9 8.2 12.2C8 12.5 8 12.7 8 13C8 14.7 9.3 16 11 16C12.7 16 14 14.7 14 13C14 11.3 12.7 10 11 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8C6.3 8 3 13 3 13C3 13 6.3 18 12 18C17.7 18 21 13 21 13C21 13 17.7 8 12 8ZM12 16C9 16 6.8 14.2 5.6 13C6.8 11.8 9 10 12 10C15 10 17.2 11.8 18.4 13C17.2 14.2 15 16 12 16Z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-open-menu",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 12L3 6V18L9 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3V21H20V3H10ZM18 19H12V5H18V19Z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-hide-menu",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 3H8V21H11V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L18 6V18L12 12Z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalog-fleet",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7 10.1C22.3 9.50003 21.9 8.50002 21.1 8.30002L16.1 7.30002C15.8 7.20002 15.5 7.10002 15.4 6.80002L12.9 2.30002C12.5 1.60002 11.5 1.60002 11.1 2.30002L8.60001 6.90002C8.40001 7.10002 8.20001 7.30002 7.90001 7.40002L2.90001 8.40002C2.00001 8.60002 1.70001 9.50003 2.30001 10.1L5.80001 13.9C5.90001 14.1 6.00001 14.4 6.00001 14.7L5.40001 19.8C5.30001 20.6 6.10001 21.2 6.90001 20.9L11.5 18.8C11.8 18.7 12.1 18.7 12.4 18.8L17 20.9C17.7 21.2 18.6 20.6 18.5 19.8L18 14.7C18 14.4 18.1 14.1 18.3 13.9L21.7 10.1ZM16.8 12.6C16.2 13.3 15.9 14.1 16 15L16.4 18.4L13.3 17C12.9 16.8 12.5 16.7 12 16.7C11.5 16.7 11.1 16.8 10.7 17L7.60001 18.4L8.00001 15C8.10001 14.1 7.80001 13.2 7.20001 12.6L4.90001 10L8.30001 9.30002C9.20001 9.10002 9.90001 8.60002 10.4 7.80002L12.1 4.80002L13.8 7.80002C14.2 8.60002 15 9.10002 15.9 9.30002L19.3 10L16.8 12.6Z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-map",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5 9 2 3 5v16l6-3 6 3 6-3V2l-6 3Zm4 12-4 2-6-3-4 2V6l4-2 6 3 4-2v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 11a3.7 3.7 0 0 1 2-3l1-1s0-1 1 0a3.1 3.1 0 0 1 1 2 3.49 3.49 0 0 0-1 2 3.49 3.49 0 0 1-1 2l-1 1a3.6 3.6 0 0 1-2-1 1.34 1.34 0 0 1 0-2ZM13 12c0-1 1-1 2-1s1-1.44 1.5-.72.67.72.58 1.72c-.09 1 1.13 0 0 1.5s-.53 2.75-1.81 2.12C13.99 14.99 14 15 14 14s-1.33-1.13-1.17-1.07c.16.06.17-.93.17-.93Z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalog-vessels",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12h19l-1 5H5l-3-5ZM19 8h-4v4h4V8ZM15 9h-1v1h1V9ZM7 7H6v5h1V7ZM11 7h-1v5h1V7Z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalog-ports",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 8H11V21H13V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 10H7V12H17V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3C10.3 3 9 4.3 9 6C9 7.7 10.3 9 12 9C13.7 9 15 7.7 15 6C15 4.3 13.7 3 12 3ZM12 7C11.4 7 11 6.6 11 6C11 5.4 11.4 5 12 5C12.6 5 13 5.4 13 6C13 6.6 12.6 7 12 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 16C17.5 18.4 14.9 20 12 20C9.09999 20 6.49999 18.4 5.09999 16H2.79999C4.29999 19.5 7.89999 22 12 22C16.1 22 19.6 19.5 21.2 16H18.9Z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-copy",
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4291_7543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83341 1.16663H5.25008H4.66675V2.91663H5.83341V2.33329H10.5001V9.33329H9.91675V10.5H10.5001H11.6667V9.33329V2.33329V1.16663H5.83341Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 3.5V12.8333H9.33337V3.5H2.33337ZM8.16671 11.6667H3.50004V4.66667H8.16671V11.6667Z",
    fill: "#464958"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4291_7543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 11.6667,
    fill: "white",
    transform: "translate(2.33337 1.16663)"
  }))))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-alert",
    viewBox: "0 0 28 28",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4496_4608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 14C27.5 21.4558 21.4558 27.5 14 27.5C6.54416 27.5 0.5 21.4558 0.5 14C0.5 6.54416 6.54416 0.5 14 0.5C21.4558 0.5 27.5 6.54416 27.5 14Z",
    fill: "#FFD600",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 19H12V23H16V19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5H12V17H16V5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4496_4608"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  }))))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-my-fleet",
    viewBox: "0 0 13 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.8 2.667h10l-.533 2.666H4.4L2.8 2.667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.133.667h-2v2.666h2V.667ZM5.467 0H4.8v3.333h.667V0ZM8.133 0h-.666v3.333h.666V0ZM10.8 8.667H.8l.533 2.666H9.2l1.6-2.666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.467 6.667h-2v2.666h2V6.667ZM8.8 6h-.667v3.333H8.8V6ZM6.133 6h-.666v3.333h.666V6Z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-more-icon",
    viewBox: "0 0 13 3",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3C7.32843 3 8 2.32843 8 1.5C8 0.671573 7.32843 0 6.5 0C5.67157 0 5 0.671573 5 1.5C5 2.32843 5.67157 3 6.5 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 3C12.3284 3 13 2.32843 13 1.5C13 0.671573 12.3284 0 11.5 0C10.6716 0 10 0.671573 10 1.5C10 2.32843 10.6716 3 11.5 3Z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-download",
    viewBox: "0 0 24 25",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4786_2339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 16.0303H3V18.0303H21V16.0303Z",
    fill: "#464958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.0303L18 10.0303H14V5.03027H10V10.0303H6L12 14.0303Z",
    fill: "#464958"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4786_2339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 13,
    fill: "white",
    transform: "translate(3 5.03027)"
  }))))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-away-icon",
    viewBox: "0 0 11 11",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 7V9H2V3H4V1H0V11H10V7H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 0H11V6H9V3.5L6 6.5L4.5 5L7.5 2H5V0Z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vessel-track",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.4546L9.5 8.45459L22 2.95459L16.5 15.4546ZM12.9 9.05459L15.8 11.9546L18.1 6.85459L12.9 9.05459Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7402,
    y: 11.0429,
    width: 2,
    height: 15.1888,
    transform: "rotate(45 12.7402 11.0429)"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vessel-save-track",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3V21H21V7L17 3H3ZM5 5H16L19 8V19H5V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4V12H16V4H6ZM11 5H14V10H11V5Z"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vessel-info",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 10H11V17H13V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7H11V9H13V7Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z",
    fill: "currentColor"
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-back",
    viewBox: "0 0 13 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.30667H2.2L6.60667 0.893333L5.71333 0L0 5.71333V6.22667L5.71333 11.94L6.60667 11.0467L2.2 6.64H12.6667V5.30667Z"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-port",
    viewBox: "0 0 12 18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00016 15.6667L5.59055 15.9535L6.00016 16.5386L6.40978 15.9535L6.00016 15.6667ZM6.00016 15.6667C6.40978 15.9535 6.40982 15.9534 6.40988 15.9533L6.4101 15.953L6.41084 15.952L6.41359 15.948L6.42403 15.933L6.46396 15.8754C6.49876 15.825 6.54955 15.7512 6.61404 15.6564C6.74301 15.4669 6.92688 15.1937 7.14735 14.8577C7.58802 14.1863 8.17633 13.2618 8.76539 12.252C9.35349 11.2438 9.94738 10.142 10.3957 9.11716C10.8358 8.1113 11.1668 7.11206 11.1668 6.33342C11.1668 5.60493 10.9883 4.33097 10.2495 3.22273C9.48952 2.08273 8.16625 1.16675 6.00016 1.16675C3.83408 1.16675 2.51081 2.08273 1.7508 3.22273C1.01198 4.33097 0.833496 5.60493 0.833496 6.33342C0.833496 7.11206 1.16452 8.1113 1.60458 9.11716C2.05294 10.142 2.64684 11.2438 3.23494 12.252C3.82399 13.2618 4.41231 14.1863 4.85297 14.8577C5.07345 15.1937 5.25732 15.4669 5.38629 15.6564C5.45078 15.7512 5.50157 15.825 5.53637 15.8754L5.5763 15.933L5.58674 15.948L5.58949 15.952L5.59023 15.953L5.59044 15.9533C5.5905 15.9534 5.59055 15.9535 6.00016 15.6667ZM6.00016 8.50008C5.42553 8.50008 4.87442 8.27181 4.4681 7.86548C4.06177 7.45915 3.8335 6.90805 3.8335 6.33342C3.8335 5.75878 4.06177 5.20768 4.4681 4.80135C4.87442 4.39502 5.42553 4.16675 6.00016 4.16675C6.5748 4.16675 7.1259 4.39502 7.53223 4.80135C7.93856 5.20768 8.16683 5.75878 8.16683 6.33342C8.16683 6.90805 7.93856 7.45915 7.53223 7.86548C7.1259 8.27181 6.5748 8.50008 6.00016 8.50008Z",
    fill: "white",
    stroke: "black"
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-terrestrial-target",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#000",
    d: "M11.5 14 8 2 4.5 14h7Z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-satellite-target",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#000",
    d: "M11 5 8 1 5 5v9l3-4 3 4V5Z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-motionless-target",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 4,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 3,
    fill: "currentColor"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-legend",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M15 5 9 2 3 5v16l6-3 6 3 6-3V2l-6 3Zm4 12-4 2-6-3-4 2V6l4-2 6 3 4-2v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M7 11a3.7 3.7 0 0 1 2-3l1-1s0-1 1 0a3.1 3.1 0 0 1 1 2 3.49 3.49 0 0 0-1 2 3.49 3.49 0 0 1-1 2l-1 1a3.6 3.6 0 0 1-2-1 1.34 1.34 0 0 1 0-2ZM13 12c0-1 1-1 2-1s1-1.44 1.5-.72.67.72.58 1.72c-.09 1 1.13 0 0 1.5s-.53 2.75-1.81 2.12C13.99 14.99 14 15 14 14s-1.33-1.13-1.17-1.07c.16.06.17-.93.17-.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M23 23v-4l-4 4h4Z"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-terminal",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.1704C11.8199 20.9279 11.5858 20.608 11.3136 20.2257C10.6621 19.3105 9.79417 18.0395 8.9271 16.615C8.05912 15.1891 7.19738 13.618 6.55404 12.1016C5.90652 10.5753 5.5 9.14927 5.5 8C5.5 6.60003 5.96925 4.96606 7.01198 3.69162C8.04194 2.43278 9.64985 1.5 12 1.5C14.3502 1.5 15.9581 2.43278 16.988 3.69162C18.0307 4.96606 18.5 6.60003 18.5 8C18.5 9.14927 18.0935 10.5753 17.446 12.1016C16.8026 13.618 15.9409 15.1891 15.0729 16.615C14.2058 18.0395 13.3379 19.3105 12.6864 20.2257C12.4142 20.608 12.1801 20.9279 12 21.1704Z",
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6H16V8H13V14H11V8H8V6Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5649_1321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-chevron-down-small",
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 10.5L2 5.5L3.5 4L7 7.5L10.5 4L12 5.5L7 10.5Z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-predicted-route",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 22.5L1.5 15.5L14 10L8.5 22.5ZM4.9 16.1L7.8 19L10.1 13.9L4.9 16.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.5884,
    y: 1,
    width: 2,
    height: 4,
    transform: "rotate(45 21.5884 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5884,
    y: 5,
    width: 2,
    height: 4,
    transform: "rotate(45 17.5884 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5884,
    y: 9,
    width: 2,
    height: 4,
    transform: "rotate(45 13.5884 9)"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-arrow-down",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6H14.08L8.04 11.92L2 6Z",
    fill: "currentColor"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-swap",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14L15 19L12 14H14V6H16V14H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10L9 5L12 10H10V18H8V10H6Z"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-routes",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3C4.6 3 3 4.6 3 6.5C3 8.4 4.6 10 6.5 10C8.4 10 10 8.4 10 6.5C10 4.6 8.4 3 6.5 3ZM6.5 8C5.7 8 5 7.3 5 6.5C5 5.7 5.7 5 6.5 5C7.3 5 8 5.7 8 6.5C8 7.3 7.3 8 6.5 8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14C15.6 14 14 15.6 14 17.5C14 19.4 15.6 21 17.5 21C19.4 21 21 19.4 21 17.5C21 15.6 19.4 14 17.5 14ZM17.5 19C16.7 19 16 18.3 16 17.5C16 16.7 16.7 16 17.5 16C18.3 16 19 16.7 19 17.5C19 18.3 18.3 19 17.5 19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16C14.8 8.10002 9 7.90002 9 7.90002V5.90002C9.1 5.90002 16.5 6.20002 18 15.8L16 16Z",
    fill: "currentColor"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-route-switch",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 14L15 19L12 14H14V6H16V14H18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 10L9 5L12 10H10V18H8V10H6Z",
    fill: "currentColor"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-weather",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 8.99988C17.9035 7.79746 17.4136 6.6603 16.6061 5.76415C15.7986 4.86801 14.7184 4.26277 13.5325 4.04197C12.3466 3.82118 11.1209 3.99712 10.045 4.54261C8.9691 5.0881 8.1028 5.97276 7.58 7.05988C7.38856 7.02457 7.19462 7.00451 7 6.99988C5.93913 6.99988 4.92172 7.42131 4.17157 8.17145C3.42143 8.9216 3 9.93902 3 10.9999C3 12.0607 3.42143 13.0782 4.17157 13.8283C4.92172 14.5785 5.93913 14.9999 7 14.9999H18C18.7956 14.9999 19.5587 14.6838 20.1213 14.1212C20.6839 13.5586 21 12.7955 21 11.9999C21 11.2042 20.6839 10.4412 20.1213 9.87856C19.5587 9.31595 18.7956 8.99988 18 8.99988Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H12L14 21H13L11 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16H14L16 21H15L13 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 16H16L18 21H17L15 16Z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-layers",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 15L3 11V13L12 17L21 13V11L12 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19L3 15V17L12 21L21 17V15L12 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3L3 7V9L12 13L21 9V7L12 3ZM12 11L5 8L12 5L19 8L12 11Z"
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-placeholder-no-photo",
    fill: "currentColor",
    viewBox: "0 0 182 182"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 21,
    fill: "currentColor",
    width: 2,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M154.5,148.5L154.5,148.5c0.9-2.8,1.5-5.7,1.5-8.5c0-10.9,0-34,0-34L89,85l-67,21c0,0,0,23.1,0,34  c0,2.8,0.6,5.8,1.5,8.7l0,0c-2.5-0.5-5-1.1-7.5-1.6v2c1.3,0.3,2.6,0.6,4,0.8c6.8,1.5,13.9,3,23,3c9.3,0,16.4-1.6,23.3-3.1  c6.9-1.5,13.5-2.9,22.2-2.9c8.8,0,15.5,1.4,22.5,3c6.8,1.5,13.9,3,23,3c9.3,0,16.4-1.6,23.3-3.1c1.6-0.3,3.1-0.7,4.7-1v-2  C159.5,147.4,157,148,154.5,148.5z M88.5,145c-17.9,0-27.4,6-45.5,6c-6.6,0-12.1-0.8-17.3-1.9c-1-3.2-1.7-6.7-1.7-9.1v-32.5l64-20.1  V145H88.5H90V87.4l64,20.1V140c0,2.3-0.7,5.9-1.7,9c-5.5,1.1-11.2,2-18.3,2C116.1,151,106.6,145,88.5,145z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    cx: 68,
    cy: 111.5,
    rx: 3,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    cx: 110,
    cy: 111.5,
    rx: 3,
    ry: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M132,51v-6H44v6H27v15l6,7v30.8l2-0.6V72.3l-6-7V53h15h88h17v12.3l-6,7v30.9l2,0.6V73l6-7V51H132z M89,51H46  v-4h84v4H89z"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-tool-ruler",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3ZM12 19C8.1 19 5 15.9 5 12C5 8.1 8.1 5 12 5C15.9 5 19 8.1 19 12C19 15.9 15.9 19 12 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99973 3.0183L2.93908 4.07895L11.7071 12.847L12.7678 11.7863L3.99973 3.0183Z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-s-ais",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.75 6.25-3.75-5-3.75 5V17.5l3.75-5 3.75 5V6.25Z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-t-ais",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 17.5 10 2.5l-4.375 15h8.75Z"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-aton",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 5.65684,
    height: 5.65684,
    transform: "rotate(-45 4 8)",
    fill: "#CFD8F7",
    stroke: "black"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-radar",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9660_878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 9.6L13 6L12.6 11.4L9 9.6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2 14.4L14.7 9L18 13.2L14.2 14.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 16.1L6.2 11.5L11.4 13L8.9 16.1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 19H17L16.4 22H7.8L6 19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H14V20H16V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17H8V21H9V17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17H11V21H12V17Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 16.8C4.6 15.5 4 13.8 4 12C4 7.6 7.6 4 12 4C16.4 4 20 7.6 20 12C20 13.9 19.3 15.7 18.1 17.1L19.6 18.4C21 16.7 21.9 14.4 21.9 12C21.9 6.5 17.4 2 11.9 2C6.4 2 2 6.5 2 12C2 14.3 2.8 16.3 4 18L5.6 16.8Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9660_878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-aircraft",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5V5.2831L9.74275 5.42875L14.5 8.2831V9.3901L10.0981 8.50971L9.60777 8.41165L9.50971 8.90194L9.00971 11.4019L8.95723 11.6643L9.14645 11.8536L11.5 14.2071V14.3596L8.12127 13.5149L8 13.4846L7.87873 13.5149L4.5 14.3596V14.2071L6.85355 11.8536L7.04277 11.6643L6.99029 11.4019L6.49029 8.90194L6.39223 8.41165L5.90194 8.50971L1.5 9.3901V8.2831L6.25725 5.42875L6.5 5.2831V5H6L6.5 4.99999V4.99995V4.9999V4.99982V4.99971V4.99959V4.99944V4.99927V4.99908V4.99886V4.99863V4.99836V4.99808V4.99778V4.99745V4.9971V4.99673V4.99634V4.99592V4.99548V4.99502V4.99454V4.99404V4.99351V4.99296V4.99239V4.9918V4.99119V4.99056V4.9899V4.98922V4.98853V4.98781V4.98706V4.9863V4.98552V4.98471V4.98388V4.98304V4.98217V4.98128V4.98036V4.97943V4.97848V4.9775V4.97651V4.97549V4.97446V4.9734V4.97232V4.97122V4.9701V4.96896V4.9678V4.96662V4.96542V4.9642V4.96296V4.96169V4.96041V4.95911V4.95778V4.95644V4.95508V4.95369V4.95229V4.95087V4.94943V4.94796V4.94648V4.94498V4.94345V4.94191V4.94035V4.93877V4.93717V4.93555V4.93391V4.93225V4.93057V4.92887V4.92716V4.92542V4.92367V4.92189V4.9201V4.91829V4.91645V4.9146V4.91273V4.91085V4.90894V4.90701V4.90507V4.90311V4.90112V4.89912V4.8971V4.89507V4.89301V4.89094V4.88884V4.88673V4.8846V4.88245V4.88029V4.8781V4.8759V4.87368V4.87144V4.86919V4.86691V4.86462V4.86231V4.85998V4.85764V4.85527V4.85289V4.8505V4.84808V4.84565V4.8432V4.84073V4.83824V4.83574V4.83322V4.83068V4.82812V4.82555V4.82296V4.82036V4.81773V4.81509V4.81244V4.80976V4.80707V4.80436V4.80164V4.7989V4.79614V4.79337V4.79057V4.78777V4.78494V4.7821V4.77924V4.77637V4.77348V4.77058V4.76765V4.76472V4.76176V4.75879V4.7558V4.7528V4.74978V4.74675V4.7437V4.74063V4.73755V4.73445V4.73134V4.72821V4.72506V4.7219V4.71873V4.71554V4.71233V4.70911V4.70587V4.70262V4.69935V4.69607V4.69277V4.68946V4.68613V4.68278V4.67942V4.67605V4.67266V4.66926V4.66584V4.66241V4.65896V4.6555V4.65202V4.64853V4.64503V4.64151V4.63797V4.63442V4.63086V4.62728V4.62369V4.62008V4.61646V4.61283V4.60918V4.60552V4.60184V4.59815V4.59445V4.59073V4.587V4.58325V4.57949V4.57572V4.57193V4.56813V4.56432V4.56049V4.55665V4.55279V4.54892V4.54504V4.54115V4.53724V4.53332V4.52939V4.52544V4.52148V4.51751V4.51352V4.50952V4.50551V4.50148V4.49745V4.4934V4.48933V4.48526V4.48117V4.47707V4.47296V4.46883V4.46469V4.46054V4.45638V4.4522V4.44802V4.44382V4.43961V4.43538V4.43115V4.4269V4.42264V4.41837V4.41408V4.40979V4.40548V4.40116V4.39683V4.39249V4.38813V4.38377V4.37939V4.375V4.3706V4.36619V4.36177V4.35733V4.35289V4.34843V4.34396V4.33948V4.33499V4.33049V4.32598V4.32145V4.31692V4.31238V4.30782V4.30325V4.29868V4.29409V4.28949V4.28488V4.28026V4.27563V4.27099V4.26634V4.26168V4.257V4.25232V4.24763V4.24293V4.23822V4.23349V4.22876V4.22402V4.21926V4.2145V4.20973V4.20495V4.20015V4.19535V4.19054V4.18572V4.18089V4.17605V4.1712V4.16634V4.16147V4.15659V4.1517V4.14681V4.1419V4.13698V4.13206V4.12713V4.12218V4.11723V4.11227V4.1073V4.10232V4.09733V4.09234V4.08733V4.08232V4.0773V4.07227V4.06723V4.06218V4.05712V4.05206V4.04698V4.0419V4.03681V4.03171V4.0266V4.02149V4.01637V4.01124V4.0061V4.00095V3.99579V3.99063V3.98546V3.98028V3.97509V3.9699V3.9647V3.95949V3.95427V3.94905V3.94381V3.93858V3.93333V3.92807V3.92281V3.91754V3.91227V3.90698V3.90169V3.89639V3.89109V3.88578V3.88046V3.87513V3.8698V3.86446V3.85911V3.85376V3.8484V3.84303V3.83766V3.83228V3.8269V3.8215V3.8161V3.8107V3.80529V3.79987V3.79444V3.78901V3.78358V3.77813V3.77268V3.76723V3.76177V3.7563V3.75083V3.74535V3.73987V3.73438V3.72888V3.72338V3.71787V3.71236V3.70684V3.70131V3.69579V3.69025V3.68471V3.67916V3.67361V3.66806V3.6625V3.65693V3.65136V3.64578V3.6402V3.63461V3.62902V3.62343V3.61783V3.61222V3.60661V3.60099V3.59537V3.58975V3.58412V3.57849V3.57285V3.56721V3.56156V3.55591V3.55025V3.54459V3.53893V3.53326V3.52759V3.52191V3.51623V3.51055V3.50486V3.49917V3.49347V3.48777V3.48207V3.47636V3.47065V3.46494V3.45922V3.4535V3.44777V3.44204V3.43631V3.43057V3.42484V3.41909V3.41335V3.4076V3.40185V3.39609V3.39034V3.38458V3.37881V3.37305V3.36728V3.36151V3.35573V3.34995V3.34417V3.33839V3.3326V3.32682V3.32103V3.31523V3.30944V3.30364V3.29784V3.29204V3.28623V3.28043V3.27462V3.26881V3.26299V3.25718V3.25136V3.24554V3.23972V3.2339V3.22807V3.22225V3.21642V3.21059V3.20476V3.19893V3.19309V3.18726V3.18142V3.17558V3.16974V3.1639V3.15806V3.15221V3.14637V3.14052V3.13468V3.12883V3.12298V3.11713V3.11128V3.10543V3.09957V3.09372V3.08787V3.08201V3.07616V3.0703V3.06444V3.05859V3.05273V3.04687V3.04101V3.03515V3.0293V3.02344V3.01758V3.01172V3.00586V3C6.5 2.91402 6.5466 2.77339 6.70293 2.57797C6.8537 2.38951 7.06712 2.19966 7.3 2.025C7.52999 1.85251 7.76269 1.70687 7.93944 1.60376C7.96053 1.59146 7.98075 1.57981 8 1.56882C8.01925 1.57981 8.03947 1.59146 8.06056 1.60376C8.23731 1.70687 8.47001 1.85251 8.7 2.025C8.93288 2.19966 9.1463 2.38951 9.29707 2.57797C9.4534 2.77339 9.5 2.91402 9.5 3V3.00586V3.01172V3.01758V3.02344V3.0293V3.03515V3.04101V3.04687V3.05273V3.05859V3.06444V3.0703V3.07616V3.08201V3.08787V3.09372V3.09957V3.10543V3.11128V3.11713V3.12298V3.12883V3.13468V3.14052V3.14637V3.15221V3.15806V3.1639V3.16974V3.17558V3.18142V3.18726V3.19309V3.19893V3.20476V3.21059V3.21642V3.22225V3.22807V3.2339V3.23972V3.24554V3.25136V3.25718V3.26299V3.26881V3.27462V3.28043V3.28623V3.29204V3.29784V3.30364V3.30944V3.31523V3.32103V3.32682V3.3326V3.33839V3.34417V3.34995V3.35573V3.36151V3.36728V3.37305V3.37881V3.38458V3.39034V3.39609V3.40185V3.4076V3.41335V3.41909V3.42484V3.43057V3.43631V3.44204V3.44777V3.4535V3.45922V3.46494V3.47065V3.47636V3.48207V3.48777V3.49347V3.49917V3.50486V3.51055V3.51623V3.52191V3.52759V3.53326V3.53893V3.54459V3.55025V3.55591V3.56156V3.56721V3.57285V3.57849V3.58412V3.58975V3.59537V3.60099V3.60661V3.61222V3.61783V3.62343V3.62902V3.63461V3.6402V3.64578V3.65136V3.65693V3.6625V3.66806V3.67361V3.67916V3.68471V3.69025V3.69579V3.70131V3.70684V3.71236V3.71787V3.72338V3.72888V3.73438V3.73987V3.74535V3.75083V3.7563V3.76177V3.76723V3.77268V3.77813V3.78358V3.78901V3.79444V3.79987V3.80529V3.8107V3.8161V3.8215V3.8269V3.83228V3.83766V3.84303V3.8484V3.85376V3.85911V3.86446V3.8698V3.87513V3.88046V3.88578V3.89109V3.89639V3.90169V3.90698V3.91227V3.91754V3.92281V3.92807V3.93333V3.93858V3.94381V3.94905V3.95427V3.95949V3.9647V3.9699V3.97509V3.98028V3.98546V3.99063V3.99579V4.00095V4.0061V4.01124V4.01637V4.02149V4.0266V4.03171V4.03681V4.0419V4.04698V4.05206V4.05712V4.06218V4.06723V4.07227V4.0773V4.08232V4.08733V4.09234V4.09733V4.10232V4.1073V4.11227V4.11723V4.12218V4.12713V4.13206V4.13698V4.1419V4.14681V4.1517V4.15659V4.16147V4.16634V4.1712V4.17605V4.18089V4.18572V4.19054V4.19535V4.20015V4.20495V4.20973V4.2145V4.21926V4.22402V4.22876V4.23349V4.23822V4.24293V4.24763V4.25232V4.257V4.26168V4.26634V4.27099V4.27563V4.28026V4.28488V4.28949V4.29409V4.29868V4.30325V4.30782V4.31238V4.31692V4.32145V4.32598V4.33049V4.33499V4.33948V4.34396V4.34843V4.35289V4.35733V4.36177V4.36619V4.3706V4.375V4.37939V4.38377V4.38813V4.39249V4.39683V4.40116V4.40548V4.40979V4.41408V4.41837V4.42264V4.4269V4.43115V4.43538V4.43961V4.44382V4.44802V4.4522V4.45638V4.46054V4.46469V4.46883V4.47296V4.47707V4.48117V4.48526V4.48933V4.4934V4.49745V4.50148V4.50551V4.50952V4.51352V4.51751V4.52148V4.52544V4.52939V4.53332V4.53724V4.54115V4.54504V4.54892V4.55279V4.55665V4.56049V4.56432V4.56813V4.57193V4.57572V4.57949V4.58325V4.587V4.59073V4.59445V4.59815V4.60184V4.60552V4.60918V4.61283V4.61646V4.62008V4.62369V4.62728V4.63086V4.63442V4.63797V4.64151V4.64503V4.64853V4.65202V4.6555V4.65896V4.66241V4.66584V4.66926V4.67266V4.67605V4.67942V4.68278V4.68613V4.68946V4.69277V4.69607V4.69935V4.70262V4.70587V4.70911V4.71233V4.71554V4.71873V4.7219V4.72506V4.72821V4.73134V4.73445V4.73755V4.74063V4.7437V4.74675V4.74978V4.7528V4.7558V4.75879V4.76176V4.76472V4.76765V4.77058V4.77348V4.77637V4.77924V4.7821V4.78494V4.78777V4.79057V4.79337V4.79614V4.7989V4.80164V4.80436V4.80707V4.80976V4.81244V4.81509V4.81773V4.82036V4.82296V4.82555V4.82812V4.83068V4.83322V4.83574V4.83824V4.84073V4.8432V4.84565V4.84808V4.8505V4.85289V4.85527V4.85764V4.85998V4.86231V4.86462V4.86691V4.86919V4.87144V4.87368V4.8759V4.8781V4.88029V4.88245V4.8846V4.88673V4.88884V4.89094V4.89301V4.89507V4.8971V4.89912V4.90112V4.90311V4.90507V4.90701V4.90894V4.91085V4.91273V4.9146V4.91645V4.91829V4.9201V4.92189V4.92367V4.92542V4.92716V4.92887V4.93057V4.93225V4.93391V4.93555V4.93717V4.93877V4.94035V4.94191V4.94345V4.94498V4.94648V4.94796V4.94943V4.95087V4.95229V4.95369V4.95508V4.95644V4.95778V4.95911V4.96041V4.96169V4.96296V4.9642V4.96542V4.96662V4.9678V4.96896V4.9701V4.97122V4.97232V4.9734V4.97446V4.97549V4.97651V4.9775V4.97848V4.97943V4.98036V4.98128V4.98217V4.98304V4.98388V4.98471V4.98552V4.9863V4.98706V4.98781V4.98853V4.98922V4.9899V4.99056V4.99119V4.9918V4.99239V4.99296V4.99351V4.99404V4.99454V4.99502V4.99548V4.99592V4.99634V4.99673V4.9971V4.99745V4.99778V4.99808V4.99836V4.99863V4.99886V4.99908V4.99927V4.99944V4.99959V4.99971V4.99982V4.9999V4.99995V5Z",
    fill: "#FF9F2E",
    stroke: "black"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-notifications",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 18 10.1081 16.5 10.4595 15C11.2793 11.1 10.4595 14.2 11.2793 10.4C11.7477 8 13.6216 8 13.6216 8H15.2613C15.2613 8 17.2523 8 17.7207 10.3C18.5405 14.2 17.7207 11.1 18.5405 14.9C18.8919 16.4 21 18 21 18C21 18 18.482 18.5 14.5 18.5C10.518 18.5 8 18 8 18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21C15.3284 21 16 20.3284 16 19.5C16 18.6716 15.3284 18 14.5 18C13.6716 18 13 18.6716 13 19.5C13 20.3284 13.6716 21 14.5 21Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 6H12V7H17V6Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19H14V22H15V19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64998 4.4C8.38523 3.41967 9.5055 2 11.5 2C12.4433 2 13.2123 2.29049 13.8104 2.76086C14.3931 3.21917 14.7642 3.80852 15.0018 4.34507C15.2399 4.88272 15.3619 5.40735 15.4254 5.78873C15.4576 5.98186 15.4759 6.14456 15.4862 6.26219C15.4914 6.32115 15.4946 6.36922 15.4966 6.40459C15.4976 6.42229 15.4983 6.43686 15.4987 6.44806L15.4993 6.46234L15.4995 6.46755L15.4995 6.46966C15.4995 6.47009 15.4996 6.47144 14.5 6.5C13.5004 6.52856 13.5004 6.52895 13.5004 6.52933L13.5005 6.53118L13.4997 6.5168C13.4988 6.5009 13.4971 6.47377 13.4938 6.43703C13.4874 6.36325 13.4751 6.25251 13.4526 6.11752C13.4068 5.84265 13.3225 5.49228 13.1731 5.15493C13.0232 4.81648 12.8256 4.53083 12.574 4.33289C12.3376 4.14701 12.0067 4 11.5 4C10.5945 4 10.0147 4.58033 9.24998 5.6C9.19745 5.67004 9.14312 5.74342 9.08709 5.8191C8.78042 6.23332 8.42295 6.71613 8.0329 7.0936C7.54512 7.56565 6.88382 8 5.99998 8H2.00033L2 6H5.99998C6.16613 6 6.35484 5.93435 6.64206 5.6564C6.90313 5.40374 7.14383 5.07999 7.45357 4.66337C7.51599 4.57941 7.58122 4.49168 7.64998 4.4ZM13.5005 6.53259L13.5005 6.53118L13.5005 6.53259Z",
    fill: "currentColor"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-spinner-light",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1H7v4h2V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11H7v4h2v-4Z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9V7h-4v2h4Z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9V7H1v2h4Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.668 3.757-1.415-1.415-2.828 2.829 1.414 1.414 2.829-2.828Z",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.575 10.827 5.16 9.412l-2.829 2.829 1.414 1.414 2.829-2.828Z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.329 13.753 1.414-1.414-2.998-2.998-1.414 1.414 2.998 2.998Z",
    opacity: 0.65
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 1h14v14H1z"
  }))))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-loader",
    viewBox: "0 0 16 16",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1H7v4h2V1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11H7v4h2v-4Z",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9V7h-4v2h4Z",
    opacity: 0.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9V7H1v2h4Z",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.668 3.757-1.415-1.415-2.828 2.829 1.414 1.414 2.829-2.828Z",
    opacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.575 10.827 5.16 9.412l-2.829 2.829 1.414 1.414 2.829-2.828Z",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.329 13.753 1.414-1.414-2.998-2.998-1.414 1.414 2.998 2.998Z",
    opacity: 0.65
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-notes",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3V21H12L21 16.5V3H3ZM19 15.3L11.5 19H5V5H19V15.3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 20V14H20V15L12 20H11Z",
    fill: "currentColor"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-playback",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 2V22L18 12L7 2ZM9 6.5L15 12L9 17.5V6.5Z",
    fill: "currentColor"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-play",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3V21L17 12L8 3Z",
    fill: "#currentColor"
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-catalog-atons",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 13H15V18H16V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 15H13V16H18V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.90002L8.90002 15.5L15.5 22.1L22.1 15.5L15.5 8.90002ZM11.6 15.5L15.5 11.6L19.4 15.5L15.5 19.4L11.6 15.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50002 1.90002L1.90002 8.50002L8.50002 15.1L15.1 8.50002L8.50002 1.90002ZM4.60002 8.50002L8.50002 4.60002L12.4 8.50002L8.50002 12.4L4.60002 8.50002Z"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-vessel-playback",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3V21L17 12L8 3Z",
    fill: "currentColor"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pagination-first-page",
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0v12L3 6l6-6ZM0 12h2V0H0v12Z"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pagination-last-page",
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12V0l6 6-6 6ZM9 0H7v12h2V0Z"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pagination-arrow-left",
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0v12L0 6l6-6Z"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-pagination-arrow-right",
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12V0L6 6L0 12Z"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-safety",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C3.42386 0.5 0.5 3.42386 0.5 7C0.5 10.5761 3.42386 13.5 7 13.5C10.5761 13.5 13.5 10.5761 13.5 7C13.5 3.42386 10.5761 0.5 7 0.5ZM7 3.5C7.47978 3.5 7.97556 3.62807 8.45726 3.83563L7 5.29289L5.54274 3.83563C6.02444 3.62807 6.52022 3.5 7 3.5ZM3.5 7C3.5 6.52022 3.62807 6.02444 3.83563 5.54274L5.29289 7L3.83563 8.45726C3.62807 7.97556 3.5 7.47978 3.5 7ZM7 10.5C6.52022 10.5 6.02444 10.3719 5.54274 10.1644L7 8.70711L8.45726 10.1644C7.97556 10.3719 7.47978 10.5 7 10.5ZM10.5 7C10.5 7.47978 10.3719 7.97556 10.1644 8.45726L8.70711 7L10.1644 5.54274C10.3719 6.02444 10.5 6.52022 10.5 7Z",
    fill: "currentColor",
    stroke: "white"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-safety-sidebar",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3ZM12 19C8.1 19 5 15.9 5 12C5 8.1 8.1 5 12 5C15.9 5 19 8.1 19 12C19 15.9 15.9 19 12 19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9495 5.63611L5.63589 16.9497L7.05009 18.3639L18.3637 7.05031L16.9495 5.63611Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3639 16.9495L7.05029 5.63593L5.63609 7.05013L16.9497 18.3637L18.3639 16.9495Z",
    fill: "currentColor"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-wp-marker",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.4287,
    r: 15,
    fill: "#DDDFEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 18.3287L10 14.4287L8.5 15.9287L14 21.4287L21.5 11.9287L20 10.4287L13.9 18.3287Z",
    fill: "white"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-world-fleet",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 5H3V16H5V5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3 4.00001C5 1.70001 3 4.00001 3 4.00001V11C3 11 5 8.70001 8.3 11C11.6 13.3 13 11 13 11V4.00001C13 4.00001 11.5 6.30001 8.3 4.00001ZM11 10C10.7 10 10.2 9.9 9.4 9.4C8.1 8.4 6.8 8.00001 5.5 8.00001C5.3 8.00001 5.1 8.00001 5 8.00001V5.10001C5.1 5.00001 5.3 5.00001 5.5 5.00001C6 5.00001 6.5 5.20001 7.2 5.70001C8.4 6.60001 9.7 7.00001 10.9 7.00001C10.9 7.00001 10.9 7.00001 11 7.00001V10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19H13V21H15V19Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 13H7V22H9V13Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 14V13C14.3 13 13.4 12.8 12.3 12C9 9.70001 7 12 7 12V19C7 19 9 16.7 12.3 19C15.6 21.3 17 19 17 19V14H15ZM15 18C14.7 18 14.2 17.9 13.4 17.4C12.1 16.5 10.8 16 9.4 16C9.2 16 9.1 16 8.9 16V13.1C9.1 13 9.3 13 9.5 13C10 13 10.5 13.2 11.2 13.7C12.5 14.6 13.8 15.1 15 15.1C15 15.1 15 15.1 15.1 15.1V18H15Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 8.00001C14 5.70001 12 8.00001 12 8.00001V13H14V14C14.9 13.9 16 14.1 17.3 15C20.6 17.3 22 15 22 15V8.00001C22 8.00001 20.5 10.3 17.3 8.00001ZM20 14C19.7 14 19.2 13.9 18.4 13.4C17.1 12.5 15.8 12 14.4 12C14.2 12 14.1 12 13.9 12V9.10001C14.1 9.00001 14.3 9.00001 14.5 9.00001C15 9.00001 15.5 9.20001 16.2 9.70001C17.5 10.6 18.8 11.1 20 11.1C20 11.1 20 11.1 20.1 11.1V14H20Z",
    fill: "currentColor"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-repeat",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 8.19998L5.1001 12.9L4.1001 6.09998L10.5001 8.19998Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 18C8.10457 18 9 17.1046 9 16C9 14.8954 8.10457 14 7 14C5.89543 14 5 14.8954 5 16C5 17.1046 5.89543 18 7 18Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8999 11C19.2999 6.60002 15.2999 3.60002 10.8999 4.10002C8.5999 4.50002 6.5999 5.80002 5.3999 7.60002L5.6999 9.60002L6.4999 9.90002C7.2999 7.90002 8.9999 6.40002 11.2999 6.10002C14.5999 5.70002 17.5999 8.00002 17.9999 11.2C18.3999 14.5 16.0999 17.5 12.8999 17.9C11.9999 18 11.1999 17.9 10.3999 17.7L9.7999 19.6C10.8999 19.9 11.9999 20 13.1999 19.9C17.4999 19.4 20.4999 15.4 19.8999 11Z",
    fill: "currentColor"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-exclamation",
    viewBox: "0 0 14 14",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5Z",
    fill: "#FFD600",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 2,
    height: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 2,
    height: 1,
    fill: "black"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-platform",
    viewBox: "0 0 34 32",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.759 16.467c-.007-.01-.015-.019-.02-.03l-2.388.535a.342.342 0 0 1-.344.338c-.033 0-.063-.01-.093-.018l-1.015 2.383 1.083.62 2.777-3.828ZM14.917 13.736l-3.222.328v3.345l1.969-.441a.342.342 0 0 1 .343-.339c.007 0 .012.003.018.004l1.115-2.617a.342.342 0 0 1-.223-.28ZM13.776 17.219a.34.34 0 0 1-.075-.1l-2.006.449v1.42l1.067.61 1.014-2.38ZM19.168 13.148l.945-1.303-3.12-1.783-1.455 3.415c.01.012.02.024.027.038l3.603-.367ZM22.155 18.988v-2.062l-1.475 1.057c.018.04.028.086.028.133a.34.34 0 0 1-.567.255l-.93.667.848 1.148 2.096-1.198ZM13.848 11.78l1.207 1.634a.353.353 0 0 1 .357-.037l1.4-3.29-2.964 1.694ZM20.046 18.248a.343.343 0 0 1 .317-.473c.086 0 .162.034.223.086l1.569-1.125v-1.513l-4.766 1.069a.331.331 0 0 1-.067.19l1.796 2.43.928-.664ZM17.266 16.033a.34.34 0 0 1 .086.108l4.803-1.076V13.01l-.019-.01-2.883.293-1.987 2.74ZM14.175 16.678a.34.34 0 0 1 .14.144l2.386-.535c0-.095.041-.18.105-.242l-1.487-2.012-.018.002-1.126 2.643ZM19.084 19.128l-3.168 2.271 1.009.577 2.998-1.713-.84-1.135ZM13.713 11.858l-2.018 1.153v.898l3.238-.33a.344.344 0 0 1 .019-.044l-1.24-1.677ZM15.512 13.937a.367.367 0 0 1-.044.036l1.475 1.996a.344.344 0 0 1 .102-.02c.028 0 .053.009.079.015l1.922-2.648-3.433.35a.343.343 0 0 1-.1.27ZM18.992 19.003l-1.787-2.418a.336.336 0 0 1-.16.045.335.335 0 0 1-.174-.053l-2.754 3.795 1.65.943 3.225-2.312ZM19.375 13.127l2.53-.258-1.656-.947-.874 1.204ZM11.692 9.124l-1.655 1.062 1.035 1.773 1.909-1.091-1.289-1.744ZM13.117 10.79l3.191-1.824-1.19-2.04-3.295 2.114 1.294 1.75ZM10.812 5.023c-.015 0-.03-.007-.045-.009l-.659 1.705.828 1.12a.342.342 0 0 1 .48.313c0 .085-.035.16-.086.22l.401.543 3.309-2.123-1.368-2.344-2.524.275a.339.339 0 0 1-.336.3ZM10.042 6.89l-.768 1.987.685 1.175L11.6 9l-.393-.533a.343.343 0 0 1-.48-.313c0-.085.035-.16.087-.219l-.771-1.043ZM10.491 4.795l-1.67.182L10 6.57l.623-1.611a.334.334 0 0 1-.131-.164ZM11.134 4.57l2.453-.269-1.53-2.622-1.054 2.727c.06.04.106.095.13.164ZM7.108 5.165l2.065 3.54.76-1.963-1.29-1.745-1.535.168ZM8.537 4.853 6.77 2.463l-.928.53L7.023 5.02l1.514-.166ZM10.476 4.641a.34.34 0 0 1 .336-.3c.016 0 .03.007.045.01l1.1-2.844-.878-1.505-4.172 2.384 1.809 2.448 1.76-.193ZM27.454 28.072l-1.697-.174 1.242 1.681L28 29.007l-.546-.935ZM22.274 27.385l3.15.323-1.724-2.333-1.494 1.847c.036.047.06.102.068.163ZM21.603 27.472l-1.576-.162.8 1.37.845-1.045a.328.328 0 0 1-.069-.163ZM21.837 23.179c0-.082.034-.154.082-.213l-1.266-1.714-3.12 1.783 1.114 1.908 3.207-1.68c-.007-.028-.017-.054-.017-.084ZM22.26 27.54a.34.34 0 0 1-.322.23.342.342 0 0 1-.146-.036l-.882 1.09L22.763 32l4.1-2.343-1.315-1.78-3.288-.338ZM21.938 27.088a.34.34 0 0 1 .148.035l1.518-1.878-1.294-1.75a.342.342 0 0 1-.385-.093l-3.2 1.675 1.206 2.068 1.686.173a.34.34 0 0 1 .321-.23ZM27.358 27.906l-2.391-4.098L23.8 25.25l1.832 2.48 1.725.176ZM22.182 22.838a.34.34 0 0 1 .256.12l1.557-.816-1.225-2.1-1.98 1.132 1.251 1.695c.044-.02.09-.03.14-.03ZM24.883 23.664l-.81-1.388-1.564.819c.007.027.017.054.017.084a.335.335 0 0 1-.09.225l1.269 1.716 1.178-1.456ZM0 15.256v1.187l2.2-1.411-2.2.224ZM5.35 13.01H0v2.09l2.487-.253L5.35 13.01ZM10.46 14.035V13.01H7.675l-.527 1.362 3.312-.337ZM10.46 18.384l-4.652-.544-.447 1.154h5.099v-.61ZM3.004 17.51a.34.34 0 0 1-.66-.076L0 17.159v1.835h5.194l.454-1.173-2.644-.31ZM6.573 15.985c-.016 0-.03-.007-.045-.009l-.663 1.715 4.595.538V14.19l-3.374.344-.323.834c.091.061.154.16.154.276 0 .188-.154.341-.344.341ZM6.975 14.39l.533-1.38H5.637l-2.809 1.802 4.147-.422ZM2.682 17.06a.34.34 0 0 1 .335.297l2.688.315.678-1.752a.334.334 0 0 1-.154-.276c0-.188.154-.34.344-.34.016 0 .03.006.045.008l.294-.76-4.372.445L0 16.627v.377l2.362.276a.343.343 0 0 1 .32-.22ZM26.72 5.183l-1.62.055-1.153 1.588.64 2.01 2.133-3.653ZM23.888 6.642l1.014-1.397-1.443.05.43 1.347ZM26.811 5.025l1.186-2.033-.896-.512-1.887 2.6 1.598-.055ZM21.788 9.537a.334.334 0 0 1-.087-.222c0-.05.012-.097.032-.14l-2.99-2.289-1.213 2.079 3.303 1.887.955-1.315ZM22.561 2.992c-.009 0-.016.005-.025.005a.343.343 0 0 1-.345-.34c0-.125.071-.229.171-.288l-.347-1.091-2.33 3.993 3.563-.123-.687-2.156ZM22.39 9.315c0 .05-.013.098-.033.14l1.292.99.833-1.427-.649-2.035-1.531 2.11c.052.06.087.136.087.222ZM22.536 2.315c.19 0 .344.153.344.341 0 .124-.07.228-.17.288l.7 2.198 1.607-.055 1.948-2.684L22.761 0l-.64 1.096.39 1.225c.008-.001.016-.006.025-.006ZM22.045 8.974a.35.35 0 0 1 .132.027l1.598-2.202-.478-1.498-3.704.127-.771 1.323 3.01 2.303a.338.338 0 0 1 .213-.08ZM22.045 9.656a.35.35 0 0 1-.132-.026l-.944 1.3 1.798 1.027.803-1.376-1.312-1.005a.338.338 0 0 1-.213.08ZM12.255 22.939a.332.332 0 0 1 .079.209c0 .02-.009.04-.013.06l3.098 1.346.886-1.519-2.913-1.664-1.137 1.568ZM11.99 22.807c.051 0 .1.013.144.034l1.123-1.548-2.19-1.25-1.219 2.09 1.871.813a.339.339 0 0 1 .27-.139ZM7.573 26.034l-1.735 2.974 1.287.735 2.536-3.495-2.088-.215ZM7.26 29.82l.993.568 1.535-.804c-.007-.028-.017-.055-.017-.084a.343.343 0 0 1 .6-.222l3.3-1.728.49-.84-4.32-.444-2.58 3.555ZM9.77 22.268l-2.112 3.619 2.108.216 1.975-2.721a.337.337 0 0 1-.096-.234c0-.022.008-.04.012-.06l-1.887-.82ZM10.46 29.5a.343.343 0 0 1-.601.221l-1.446.758L11.075 32l2.45-4.199-3.082 1.615c.007.027.017.054.017.084ZM11.99 23.488a.342.342 0 0 1-.117-.023l-1.928 2.656 4.302.441 1.093-1.874-3.08-1.339a.34.34 0 0 1-.27.14Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.297 15.117v1.113l2.073-1.323-2.073.21ZM28.339 13.011h-5.042v1.96l2.344-.237 2.698-1.723ZM33.153 13.972v-.96H30.53l-.497 1.276 3.12-.316ZM33.153 18.05l-4.383-.51-.421 1.082h4.804v-.572ZM26.128 17.231a.32.32 0 0 1-.622-.072l-2.209-.258v1.72l4.894.001.428-1.1-2.491-.291ZM29.491 15.8c-.015 0-.028-.006-.042-.008l-.625 1.608 4.33.504v-3.786l-3.18.322-.304.782c.086.058.145.15.145.26 0 .175-.145.319-.324.319ZM29.87 14.305l.502-1.293H28.61L25.962 14.7l3.907-.396ZM25.824 16.808a.32.32 0 0 1 .316.279l2.533.295.639-1.642a.313.313 0 0 1-.145-.259c0-.176.145-.32.324-.32.015 0 .028.007.042.009l.277-.713-4.12.417-2.393 1.528v.353l2.226.26a.323.323 0 0 1 .301-.207Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSprite);
export default __webpack_public_path__ + "static/media/IconSprite.42bf3e168862fa41a469e63e89646d39.svg";
export { ForwardRef as ReactComponent };